import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Subject, takeUntil, timer } from 'rxjs';
import { intersectionObserverConfig } from '../../directive/intersection-observer/intersection-observer.directive';
import { GeneralService } from '../../service/general.service';

type TooltipDirection = 'up' | 'down' | 'left' | 'right' | 'historyDate' | 'historyDateSecond';

const PositionsMap: Record<TooltipDirection, ConnectedPosition> = {
  up: {
    originX: 'center',
    originY: 'top',
    overlayX: 'center',
    overlayY: 'bottom',
    panelClass: 'tooltip-overlay-up',
  },
  down: {
    originX: 'center',
    originY: 'bottom',
    overlayX: 'center',
    overlayY: 'top',
    panelClass: 'tooltip-overlay-down',
  },
  left: {
    originX: 'start',
    originY: 'center',
    overlayX: 'end',
    overlayY: 'center',
    panelClass: 'tooltip-overlay-left',
  },
  right: {
    originX: 'end',
    originY: 'center',
    overlayX: 'start',
    overlayY: 'center',
    panelClass: 'tooltip-overlay-right',
  },
  historyDate: {
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
    panelClass: 'tooltip-overlay-history-date',
    offsetY: -26,
  },
  historyDateSecond: {
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
    panelClass: 'tooltip-overlay-history-date',
    offsetY: -34,
  },
};

@Component({
  selector: 'app-tool-tip',
  templateUrl: './tool-tip.component.html',
  styleUrls: ['./tool-tip.component.scss'],
})
export class ToolTipComponent implements OnChanges {
  constructor(private generalService: GeneralService) {}

  tooltipStatus: boolean = false;
  showPop$: Subject<boolean> = new Subject();
  copySuccess: string = 'Copy successful';
  tooltipClass!: boolean;
  positions: ConnectedPosition[] = [];

  @Input() state?: boolean;
  @Input() copyMode: 'icon' | 'custom' | null = null;
  @Input() copyContent?: string;
  @Input() copyIcon?: string = 'icon-copy';
  @Input() overlayMaxWidth?: string;
  @Input() direction: TooltipDirection[] = ['up', 'down', 'left', 'right'];
  @Input() intersectionObserver: boolean = true;
  @Input() tooltipsConfig!: intersectionObserverConfig;
  @Input() arrow: boolean = true;
  @Input() light?: boolean;

  @Output() afterCopy: EventEmitter<any> = new EventEmitter();

  ngOnChanges(changes: SimpleChanges): void {
    const { direction } = changes;
    if (!direction || !direction.currentValue) {
      return;
    }

    this.positions = <ConnectedPosition[]>direction.currentValue.map((v: TooltipDirection) => PositionsMap[v]);
  }

  showPop(skipRepeat: boolean = true) {
    if (skipRepeat && this.tooltipStatus) return;
    this.closePop();
    this.showPop$.next(true);
    this.tooltipStatus = true;
  }

  copy() {
    if (!this.copyContent) return;
    if (this.generalService.copyText(this.copyContent)) {
      this.afterCopy.emit();
      this.showPop();
      this.closePop(1000);
    }
  }

  closePop(time: number = 0) {
    if (time > 0) {
      timer(time)
        .pipe(takeUntil(this.showPop$))
        .subscribe(() => {
          this.tooltipStatus = false;
        });
    } else {
      this.tooltipStatus = false;
    }
  }

  onIntersectFullChange(event: any) {
    this.tooltipClass = event[0].isIntersecting;
  }
}
